module.exports = __webpack_public_path__ + "src/assets/images/product-icons/icon-roofing.png?02422edb6e9d620b414cb6510218f9d2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product-icons/icon-roofing.png
// module id = 1045
// module chunks = 1